import { useEffect, useState } from "react";

/**
 * Message-match note for visitors arriving from the /quiz funnel.
 *
 * STRICTLY ADDITIVE AND OPTIONAL:
 * - Reads the `path` URL param only. No param (the main LP funnel, ads, direct
 *   traffic) means this renders NOTHING and the checkout is byte-identical to
 *   what it has always been.
 * - Touches no payment logic, no amount, no plan, no tracking. It is display
 *   only, so it cannot affect the transfer total or any pixel/CAPI event.
 *
 * Copy rule: it restates the GOAL the visitor picked, never a different
 * product, price, curriculum or guarantee. All three income paths are covered
 * by the same course, so nothing here implies a separate track.
 */

const GOALS = {
  beginner_job: "Get hired in digital marketing",
  beginner_freelance: "Start freelancing and land your first client",
  beginner_business: "Launch and market your own business",
  freelancer_clients: "Land $500+ international clients",
  freelancer_pricing: "Charge what you're worth",
  business_notconverting: "Make your ad spend actually sell",
  business_notrunning: "Launch your first campaign the right way",
};

export default function PathNote() {
  const [goal, setGoal] = useState(null);

  useEffect(() => {
    try {
      const key = new URLSearchParams(window.location.search).get("path");
      if (key && Object.prototype.hasOwnProperty.call(GOALS, key)) {
        setGoal(GOALS[key]);
      }
    } catch {
      /* never let this break checkout */
    }
  }, []);

  if (!goal) return null;

  return (
    /* Uses <div> rather than <p> on purpose: index.css has
       `#react-checkout p { font-size: 16px }`, an ID selector that outranks
       Tailwind's text-size utilities and would flatten this whole block to
       16px. Divs keep the intended type scale without touching global CSS. */
    <div className="mx-auto mb-4 w-full max-w-xl px-4">
      <div className="rounded-xl border border-orange-200 bg-orange-50 px-4 py-3">
        <div className="text-[10px] font-black uppercase tracking-widest text-orange-600">
          Your goal
        </div>
        <div className="mt-1 text-[15px] font-bold leading-snug text-gray-900">
          {goal}
        </div>
        <div className="mt-1 text-[12px] font-medium leading-snug text-gray-600">
          Everything you need for this is inside. Same course, same price,
          lifetime access.
        </div>
      </div>
    </div>
  );
}
